import { render, staticRenderFns } from "./multipleFile.vue?vue&type=template&id=468c43b4&lang=pug"
import script from "./multipleFile.vue?vue&type=script&lang=js"
export * from "./multipleFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports